<script>
import { readonly, ref, toRaw } from 'vue'
// import productsCSV from '../products.csv'

export default {
  newOrder: {},
  product: {},
  items: {},
  displayArr: [],


  props: {
    order: Object,
    store: String,
    productsCSV: Object,
    selected: String,
    curBarcode: String,
  },
  data() {
    return {
      orderNum: '',
      customerName: '',
      images: [],

      displayItem: '',
      displaySku: '',
      displayImg: '',
      displayArr: [],
      oosColor: '',

      productList: [],
      quant: 0
    }
  },
  methods: {

  },
  updated() {
    console.log("selected: " + this.selected)
    if(this.selected == this.newOrder.orderNumber){
      console.log('This is the correct order to check!')

      // for(var i = 0; i < this.newOrder.items; i++){
      //   if ((this.newOrder.items[i].upc === this.curBarcode) || (this.newOrder.items[i].sku === this.curSKU)){
      //     console.log('correct item!')
      //   }
      // }
      for(var i = 0; i< this.newOrder.items.length; i++){
        if(this.newOrder.items[i].upc){
          console.log("this has upc")
          if((this.curBarcode === this.newOrder.items[i].upc)){
            console.log("this is the correct barcode!")
          }
        }else if(this.newOrder.items[i].sku){
          console.log("this only has sku")
        }
        else{//barcode isn't correct, check for sku
          // if(tempProd['Variant SKU'] === this.newOrder.items[i].sku){
          //   console.log("variant sku: " + tempProd['Variant SKU'])
          //   console.log("This is the correct SKU!!!")
          // }
        }
      }


      //this.curBarcode ; // The variable with the text to match

      // Find the first user object where the 'name' property matches the searchName variable
      //users.find(user => user.name === searchName)
      // if(this.)

      console.log(this.productList)//items in product list that relate to ss
      console.log(this.newOrder.items)//items in ss
    }
  },
  created() {
    //unproxies the order passed as a prop
    this.newOrder = toRaw(this.order)
    // console.log(this.newOrder)

    this.orderNum = this.newOrder.orderNumber
    this.items = this.newOrder.items

    if (this.newOrder.shipTo) {
      this.customerName = this.newOrder.shipTo.name
    }
    console.log(this.productsCSV)

    // if there are items
    if (this.items) {
      //loop through items object
      for (var i = 0; i < Object.keys(this.items).length; i++) {
        //if the item is total discount, just skip it
        if (this.items[i].sku != 'total-discount') {
          //this.product is the product from productCSV that matches the same sku number
          this.product = this.productsCSV.filter((el) => el['Variant SKU'] === this.items[i].sku)[0]

          this.productList.push(this.product)
          this.displaySku = this.items[i].sku
          this.quant = this.items[i].quantity
          if (this.items[i].name != 'Total Discount') {
            this.displayItem = this.items[i].name
          } else {
            this.displayItem = ''
          }

          //for some reason there are two places where images are stored.
          //if one image doesnt exist, then pull from the other source
          if (this.product) {
            if (this.product['Variant Image']) {
              this.images.push(this.product['Variant Image'])
              this.displayImg = this.product['Variant Image']
            } else {
              this.images.push(this.product['Image Src'])
              this.displayImg = this.product['Variant Src']
            }
          }

          this.displayArr.push({
            name: this.displayItem,
            sku: this.displaySku,
            image: this.displayImg,
            quantity: this.quant
          })
        }
        // this.displayObj.push({
        //   name: itemName,
        //   sku: skuNum,
        //   image: img,
        // })
        // this.displayArr.push(tempObj)
        //   if (this.items[i].sku == 'Total Discount') {
        // console.log(this.items[i].sku)
        //   }
      }
    }
    // this.items.forEach((selectedItem) => {
    //   console.log(selectedItem.sku)
    // })
    // this.items.forEach((stuff) => console.log(stuff))
    console.log(this.displayObj)
  },
}
</script>

<template>

  <div class="main">
    <div class="top-text">
      <h2>{{ this.orderNum }}</h2>
      <h4>{{ this.customerName }}</h4>
    </div>

    <!-- <div class="images" v-for="image in this.images">
      <img :src="image" alt="item image" />
    </div> -->

    <div class="items" v-for="item in this.displayArr">

      <img :src="item.image" alt="display image" />
      <p>
        <span>{{ item.sku }}</span>
        {{ item.name }}


      </p>
      <div class="quant">
          x{{ item.quantity }}
        </div>

      <br />
    </div>
  </div>
</template>

<style lang="scss" scoped>
img {
  width: 5em;
  height: 5em;
  object-fit: cover;
}
.main {
  background-color: rgb(33, 33, 75);
  /* width: 10em; */
  /* text-align: center; */
  padding: 1em;

  border-radius: 0.5em;
  width: 75%;
  margin: auto;
  margin-bottom: 1em;
}
.top-text {
  text-align: left;
  h2 {
    margin: 0em;

  }
  h4 {
    margin: 0em;
  }
  // padding-left: 10%;

}
.items {
  display: flex;

  margin-top: 1em;

  span {
    color: rgb(248, 158, 173);
    margin-right: 0.5em;
  }
  p {
    display: flex;
    align-items: center;
    padding-left: 1.5em;
    font-size: 1.25em;
  }
}
.quant{
  display: flex;
  align-items: center;
  padding-left: 2em;
}
.yes-no {
  padding: 0.5em;
  button {
    border: none;
    cursor: pointer;
    appearance: none;
    background-color: inherit;

    &:hover {
      opacity: 75%;
    }
  }
  img {
    width: 2em;
    height: 2em;
  }
}
</style>
